module.exports = __webpack_public_path__ + "img/quote-4.ef16ab70.webp";